import { render } from "./VideoPlayerControlsPip.vue?vue&type=template&id=97079f72&scoped=true"
import script from "./VideoPlayerControlsPip.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsPip.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsPip.vue?vue&type=style&index=0&id=97079f72&scoped=true&lang=css"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97079f72"]])

export default __exports__